// extracted by mini-css-extract-plugin
export default {"root":"FeaturesFilter_root__7v9G8","filter":"FeaturesFilter_filter__hyuZj"};